module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="social-bnt-frame">\r\n	<!-- Put this div tag to the place, where the Like block will be -->\r\n	<div id="vk_like44113" style="display: inline-block;"></div>\r\n</div>';
}
return __p;
};
